var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCartFailedMobile = function SvgIconCartFailedMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46 40a6 6 0 1 1 12 0zm-4 0h-6a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h32a2 2 0 0 0 2-2V42a2 2 0 0 0-2-2h-6c0-5.523-4.477-10-10-10s-10 4.477-10 10m4 8a6 6 0 1 0 12 0h4c0 5.523-4.477 10-10 10s-10-4.477-10-10z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 57.5,
    y: 59.5,
    rx: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C62828",
    d: "M66.5 75.166a6.667 6.667 0 1 1 0-13.333 6.667 6.667 0 0 1 0 13.333m0-7.61-1.885-1.885-.943.943 1.885 1.886-1.885 1.885.943.943 1.885-1.886 1.886 1.886.943-.943-1.886-1.885 1.886-1.886-.943-.943z"
  })));
};
export default SvgIconCartFailedMobile;